<template>
    
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/wNJbAO7RA36CLhJTP_PDog" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1734668686829026.jpg" alt="澳门举办景德镇陶瓷艺术数字展 推动文化交流与艺术融合" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/04<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门举办景德镇陶瓷艺术数字展 推动文化交流与艺术融合</div>
                                <div class="desc">由大湾区陶艺收藏交流协会、景德镇国家陶瓷版权交易中心、澳门中葡商贸促进协会主办，澳门永利渡假村、宝顺拍卖、六蚁商业贸易行、澳门质量品牌国际认证联盟、澳门融贯数链科技有限公司、景德国际陶瓷版权服务（珠海横琴）有限公司协办的「东方之美 瓷动人心」陶瓷艺术数字展览已于12月4日在永利皇宫鸿翊廷盛大开幕，展览期将持续至12月18日。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/k571TmFLIk1OlBvNsTLVHw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1734668504770563.png" alt="澳门融贯助力“湾区认证”打造一物一码防伪身份ID，实现全程追溯与保护" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/29<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯助力“湾区认证”打造一物一码防伪身份ID，实现全程追溯与保护</div>
                                <div class="desc">澳门融贯投资科技有限公司作为“湾区认证”发起单位、副理事长单位，在市场监管总局和粤港澳三地职能部门的政策支持与决策带领下，通过拓展“一物一码防伪身份ID”与数字化溯源技术深耕，积极服务“湾区认证”采信场景。全程深度参与“湾区认证” 顶层设计及水培蔬菜与淡水鱼生等项目筹备工作：从标志设计、项目研发到数字认证一物一码溯源技术支持。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/R7Wi0HPJA4U4p6I_xsFv7g" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1734668266639767.jpg" alt="澳门质量品牌国际认证联盟参编四项ESG湾区标准，开启绿色经济新机遇" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/08<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门质量品牌国际认证联盟参编四项ESG湾区标准，开启绿色经济新机遇</div>
                                <div class="desc">2024年11月8日，由中国贸促会贸易推广交流中心指导，广东省绿色贸易标准化技术委员会主办，广东贸促国际商事认证中心承办的的“ESG湾区标准发布及研讨会”在广州东山宾馆隆重举行。澳门质量品牌国际认证联盟作为标准文件起草单位之一，参编会上四项ESG湾区标准，有效提高国际市场竞争力，开启绿色经济新机遇。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/uHwu54mzc9HR6Xf5x7uFHQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1729505346702847.jpg" alt="澳门质量品牌国际认证联盟携手中国电子商会、融贯国际亮相第29届MIF" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/19<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门质量品牌国际认证联盟携手中国电子商会、融贯国际亮相第29届MIF</div>
                                <div class="desc">10月16日-19日，第二十九届澳门国际贸易投资展览会（简称：第29届MIF）在澳门威尼斯人金光会展如期举行。澳门特别行政区行政长官、合作区管委会主任贺一诚一行出席开幕仪式。澳门质量品牌国际认証联盟携手中国电子商会及融贯国际亮相第29届MIF，展示链网协同技术全新实践场景,加速国际服务能力落地。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/NrOdz49EdxrAK0VFZhJt0w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1729505271100117.png" alt="2024第二届国际贸易数字化与跨境电商创新发展论坛在澳举行" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/17<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">2024第二届国际贸易数字化与跨境电商创新发展论坛在澳举行</div>
                                <div class="desc">10月17日，“2024第二届国际贸易数字化与跨境电商创新发展论坛”在澳门召开，本次论坛由澳门质量品牌国际认证联盟、中国电子商会、全球数字经济联盟（D50）联合主办。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/SL-eJIPP6tFm3ciyZ9PTBw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1729505210104688.jpg" alt="“融通中葡，汇贯商贸”｜澳门中葡商贸促进协会正式成立！" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/17<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">“融通中葡，汇贯商贸”｜澳门中葡商贸促进协会正式成立！</div>
                                <div class="desc">10月17日上午，澳门中葡商贸促进协会于金光会展中心西西里厅，召开首次专题论坛暨协会成立仪式，选举产生了第一届领导成员架构，冯信坚当选创会会长，冯文滔当选会长，陈志峰当选理事长，吴文慧当选监事长、陈祥当选秘书长</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/_MkUzGi_r4YuZPXY4ZWUEw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1729505522426782.jpg" alt="岑浩辉晤澳门质量品牌国际认证联盟何敬麟冯文滔一行" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/10<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">岑浩辉晤澳门质量品牌国际认证联盟何敬麟冯文滔一行</div>
                                <div class="desc">第六任行政长官候选人岑浩辉在代理人李焕江、竞选办公室主任叶兆佳等陪同下，10月10日中午12时在竞选办公室会见澳门质量品牌国际认证联盟执行会长何敬麟、理事长冯文滔、监事长吴在权一行十人</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/kMdVa7OHlrjQl8LmjdkEfQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1729505099378967.jpg" alt="深化交流 共谋发展 | 澳门融贯总经理陈祥一行参访广东映客互娱网络信息有限公司" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/29<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">深化交流 共谋发展 | 澳门融贯总经理陈祥一行参访广东映客互娱网络信息有限公司</div>
                                <div class="desc">9月29日｜澳门融贯投资科技有限公司总经理陈祥一行到广东映客互娱网络信息有限公司参访，与映宇宙集团高级副总裁、总编辑夏晓晖、广东映客政府事务总监李彥君等相关负责人座谈交流。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>